
export const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID!,
    ClientId: process.env.REACT_APP_APPLICATION_ID!
};
  